import { render } from "./AlertHandler.vue?vue&type=template&id=f966d538"
import script from "./AlertHandler.vue?vue&type=script&lang=js"
export * from "./AlertHandler.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__